import React from "react";
import { AuthContainer } from "./style";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as authApi from "api/auth";
import isMobilePhone from "validator/lib/isMobilePhone";
import Input from "components/input";
import Button from "components/button";
import Select from "components/select";
import { FiSmartphone, FiUserCheck, FiKey, FiUser } from "react-icons/fi";
import OTPInput from "otp-input-react";
import Counter from "./counter";
import MainContext from "contexts/main";
import Modal from "components/modal";
import Policy from "./policy";
const Auth = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/";
  const [modalStatus, setModalStatus] = React.useState(false);
  const { setUser } = React.useContext(MainContext);
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "TOGGLE_LOADING":
          return { ...state, loading: !state.loading };
        case "SET_TYPE":
          return { ...state, type: action.payload };
        case "CHANGE_VALUE":
          return {
            ...state,
            formData: {
              ...state.formData,
              [action.payload.name]: action.payload.value,
            },
          };
        case "VERIFY":
          return {
            ...state,
            verifyData: action.payload,
            formData: {
              ...state.formData,
              verifyCode: "",
            },
            loading: false,
            type: "verify",
          };
        case "SET_FORM_ERRORS":
          return { ...state, formErrors: action.payload, loading: false };
        default:
          return state;
      }
    },
    {
      type: "otp",
      loading: false,
      formData: {
        username: "",
        phone: "",
        national_code: "",
        verifyCode: "",
        password: "",
        password_confirmation: "",
        user_type: "",
      },
      verifyData: {},
      formErrors: {},
      status: null,
    }
  );
  const checkDataError = (type) => {
    const errors = {};
    if (type === "login") {
      if (!state.formData.username) errors.username = "اجباری می باشد";
      if (!state.formData.password) {
        errors.password = "اجباری می باشد";
      }
      if (state.formData.password.length < 6) {
        errors.password = "حداقل 6 کاراکتر می باشد";
      }
    }
    if (type === "otp") {
      if (!state.formData.phone) errors.phone = "اجباری می باشد";
      if (!isMobilePhone(state.formData.phone, "fa-IR"))
        errors.phone = "شماره موبایل معتبر نیست";
    }
    if (type === "register") {
      if (!state.formData.phone) errors.phone = "اجباری می باشد";
      if (!isMobilePhone(state.formData.phone, "fa-IR"))
        errors.phone = "شماره موبایل معتبر نیست";
      if (!state.formData.national_code)
        errors.national_code = "اجباری می باشد";
      if (!state.formData.user_type) errors.user_type = "اجباری می باشد";
      // if (
      //   !Number(state.formData.national_code) ||
      //   state.formData.national_code.length !== 10
      // )
      //   errors.national_code = "معتبر نیست";
      if (!state.formData.password) {
        errors.password = "اجباری می باشد";
      }
      if (state.formData.password.length < 6) {
        errors.password = "حداقل 6 کاراکتر می باشد";
      }
      if (state.formData.password_confirmation !== state.formData.password) {
        errors.password_confirmation = "تکرار رمز عبور اشتباه است";
      }
    }
    if (type === "verify") {
      if (!state.formData.verifyCode) errors.verifyCode = "اجباری می باشد";
      if (state.formData.verifyCode.length < 5)
        errors.verifyCode = "معتبر نیست";
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    } else {
      return false;
    }
  };
  const doLogin = async () => {
    dispatch({ type: "TOGGLE_LOADING" });
    const errors = checkDataError("login");
    if (errors) {
      dispatch({ type: "SET_FORM_ERRORS", payload: errors });
    } else {
      await authApi
        .login(state.formData)
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          setUser(res.data);
          if (!res.data.profile.has_profile) {
            navigate("/profile", { replace: true });
          } else {
            navigate(from, { replace: true });
          }
        })
        .catch((err) => {
          dispatch({ type: "TOGGLE_LOADING" });
        });
    }
  };
  const doRegister = async () => {
    dispatch({ type: "TOGGLE_LOADING" });
    const errors = checkDataError("register");
    if (errors) {
      dispatch({ type: "SET_FORM_ERRORS", payload: errors });
    } else {
      await authApi
        .register(state.formData)
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          setUser(res.data);
          if (!res.data.profile.has_profile) {
            navigate("/profile", { replace: true });
          } else {
            navigate(from, { replace: true });
          }
        })
        .catch((err) => {
          dispatch({ type: "TOGGLE_LOADING" });
        });
    }
  };
  const doOtp = async () => {
    dispatch({ type: "TOGGLE_LOADING" });
    const errors = checkDataError("otp");
    if (errors) {
      dispatch({ type: "SET_FORM_ERRORS", payload: errors });
    } else {
      await authApi
        .recover(state.formData)
        .then((res) => {
          dispatch({ type: "VERIFY", payload: res.data });
        })
        .catch((err) => {
          dispatch({ type: "TOGGLE_LOADING" });
        });
    }
  };
  const doVerify = async () => {
    dispatch({ type: "TOGGLE_LOADING" });
    const errors = checkDataError("verify");
    if (errors) {
      dispatch({ type: "SET_FORM_ERRORS", payload: errors });
    } else {
      await authApi
        .verify({ ...state.verifyData, code: state.formData.verifyCode })
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          setUser(res.data);
          if (!res.data.profile.has_profile) {
            navigate("/profile", { replace: true });
          } else {
            navigate(from, { replace: true });
          }
        })
        .catch((err) => {
          dispatch({ type: "TOGGLE_LOADING" });
        });
    }
  };

  const handleChange = (e) => {
    dispatch({
      type: "CHANGE_VALUE",
      payload: { name: e.target.name, value: e.target.value },
    });
  };
  const reSendCode = () => {
    doOtp();
  };
  const typeView = () => {
    switch (state.type) {
      case "register":
        return (
          <section className="form">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                doRegister();
              }}
            >
              <div className="form-item">
                <Select
                  label="نوع کاربری"
                  name="user_type"
                  value={state.formData.user_type}
                  onChange={handleChange}
                  error={state.formErrors.user_type}
                  options={[
                    { id: "person", title: "حقیقی" },
                    { id: "company", title: "حقوقی" },
                  ]}
                />
              </div>
              <div className="form-item">
                <Input
                  label="کد ملی/شناسه ملی"
                  name="national_code"
                  type="number"
                  value={state.formData.national_code}
                  onChange={handleChange}
                  error={state.formErrors.national_code}
                  ltr
                  icon={<FiUserCheck />}
                />
              </div>
              <div className="form-item">
                <Input
                  label="تلفن همراه"
                  placeholder="091*******"
                  type="number"
                  name="phone"
                  value={state.formData.phone}
                  onChange={handleChange}
                  error={state.formErrors.phone}
                  ltr
                  icon={<FiSmartphone />}
                />
              </div>
              <div className="form-item">
                <Input
                  label="کلمه عبور"
                  name="password"
                  type="password"
                  value={state.formData.password}
                  onChange={handleChange}
                  error={state.formErrors.password}
                  ltr
                  icon={<FiKey />}
                />
              </div>
              <div className="form-item">
                <Input
                  label="تکرار کلمه عبور"
                  name="password_confirmation"
                  type="password"
                  value={state.formData.password_confirmation}
                  onChange={handleChange}
                  error={state.formErrors.password_confirmation}
                  ltr
                  icon={<FiKey />}
                />
              </div>
              <div className="buttons">
                <Button title="ثبت نام" loading={state.loading} />
              </div>
              <div className="notice">
                قبلا ثبت نام کرده اید؟
                <span
                  className="link"
                  onClick={() =>
                    dispatch({ type: "SET_TYPE", payload: "login" })
                  }
                >
                  وارد شوید
                </span>
              </div>
            </form>
            <Modal
              status={modalStatus}
              size="big"
              close={() => setModalStatus(false)}
            >
              <Policy />
            </Modal>
          </section>
        );
      case "otp":
        return (
          <section className="form">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                doOtp();
              }}
            >
              <div className="form-item">
                <Input
                  label="تلفن همراه"
                  placeholder="091*******"
                  type="number"
                  name="phone"
                  value={state.formData.phone}
                  onChange={handleChange}
                  error={state.formErrors.phone}
                  ltr
                  icon={<FiSmartphone />}
                />
              </div>

              <div className="buttons">
                <Button title="درخواست" loading={state.loading} />
              </div>
              <div className="notice">
                قبلا ثبت نام کرده اید؟
                <span
                  className="link"
                  onClick={() =>
                    dispatch({ type: "SET_TYPE", payload: "login" })
                  }
                >
                  وارد شوید
                </span>
              </div>
            </form>
          </section>
        );
      case "verify":
        return (
          <section className="form">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                doVerify();
              }}
            >
              <div className="form-item">
                <label>کد ارسال شده را وارد کنید</label>
                <OTPInput
                  className="otp"
                  value={state.formData.verifyCode}
                  onChange={(value) =>
                    dispatch({
                      type: "CHANGE_VALUE",
                      payload: { name: "verifyCode", value: value },
                    })
                  }
                  autoFocus
                  OTPLength={5}
                  otpType="number"
                  disabled={false}
                />
              </div>
              <div className="form-item">
                <Counter reSendCode={reSendCode} />
              </div>
              <div className="buttons">
                <Button title="تایید" loading={state.loading} />
              </div>
            </form>
          </section>
        );
      default:
        return (
          <section className="form">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                doLogin();
              }}
            >
              <div className="form-item">
                <Input
                  label="نام کاربری (موبایل یا کد ملی)"
                  type="number"
                  name="username"
                  value={state.formData.username}
                  onChange={handleChange}
                  error={state.formErrors.username}
                  ltr
                  icon={<FiUser />}
                />
              </div>
              <div className="form-item">
                <Input
                  label="کلمه عبور"
                  name="password"
                  type="password"
                  value={state.formData.password}
                  onChange={handleChange}
                  error={state.formErrors.password}
                  ltr
                  icon={<FiKey />}
                />
              </div>
              <div className="buttons">
                <Button title="ورود" loading={state.loading} />
              </div>
              <div className="notice">
                ثبت نام نکرده اید؟
                <span
                  className="link"
                  onClick={() =>
                    dispatch({ type: "SET_TYPE", payload: "register" })
                  }
                >
                  ثبت نام
                </span>
              </div>{" "}
              <div className="notice">
                کلمه عبور خود را فراموش کرده اید؟
                <span
                  className="link"
                  onClick={() => dispatch({ type: "SET_TYPE", payload: "otp" })}
                >
                  بازیابی کلمه عبور
                </span>
              </div>
            </form>
          </section>
        );
    }
  };
  return <AuthContainer>{typeView()}</AuthContainer>;
};
export default Auth;
